import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { stat } from 'fs';
//import { FaDownload } from "react-icons/fa"; // Corrija o import aqui
import { Container, Section, Table, Th, Td, Title, SubTitle, ParecerTextArea, SaveButton, ReturnButton } from './style';
import { SumulaModel, EmpresaGrupo, SumulaObterResponse } from '../../models/sumula.model';
import { Header } from "../Header";
import { IUser } from '../Login/ILogin';
import { getSessionUser } from '../../utils/users';
import { apiPetro, apiExtractor, headers } from "../../services/api";
import { maskNumber } from '../../utils/mask';
import { formatDateToBR } from '../../utils';

// Adicione a interface DecisaoDiretoriaModel
interface DecisaoDiretoriaModel {
    codigoGrupo: string;
    limiteAtual: string;
    limiteProposto: string;
    limiteSugerido: string;
    decisao: string;
    condicionantes: string;
    limiteCredito: string;
    modalidade: string;
    conceito: string;
    prazoDeferido: string;
}

// Funções de máscara
function maskCnpjCpf(value: string) {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    if (value.length <= 11) {
        // CPF: 000.000.000-00
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, function (_, a, b, c, d) {
            return [a, b, c].filter(Boolean).join('.') + (d ? '-' + d : '');
        });
    } else {
        // CNPJ: 00.000.000/0000-00
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, function (_, a, b, c, d, e) {
            return [a, b, c].filter(Boolean).join('.') + (d ? '/' + d : '') + (e ? '-' + e : '');
        });
    }
}

function maskPhone(value: string) {
    if (!value) return '';
    value = value.replace(/\D/g, '');
    if (value.length <= 10) {
        // (00) 0000-0000
        return value.replace(/(\d{2})(\d{4})(\d{0,4})/, function (_, a, b, c) {
            return '(' + a + ') ' + b + (c ? '-' + c : '');
        });
    } else {
        // (00) 00000-0000
        return value.replace(/(\d{2})(\d{5})(\d{0,4})/, function (_, a, b, c) {
            return '(' + a + ') ' + b + (c ? '-' + c : '');
        });
    }
}

function mapTipoCliente(codigo: string | number) {
    const tiposCliente: { [key: string]: string } = {
        '001': 'REVENDA PETROBAHIA',
        '002': 'REVENDA B BRANCA',
        '003': 'AGRONEGOCIO', 
        '004': 'TRANSPORTADORAS',
        '005': 'INDUSTRIA',
        '006': 'CLIENTES LUBRIFICANTES',
        '007': 'DISTRIBUIDOR CONGENERE',
        '008': 'REVENDA OUTRAS BANDEIRAS',
        '009': 'MARITMO',
        '010': 'COMERCIO E SERVIÇOS',
        '011': 'REVENDA E AVIACAO',
        '012': 'CONSUMIDOR AVIACAO',
        '013': 'DISTRIBUIDOR AVIACAO',
        '014': 'TRR - TRANSP RETALHISTA',
        '015': 'TRR - CONTA E ORDEM'
    };
    
    const codigoStr = codigo?.toString();
    return tiposCliente[codigoStr] || codigoStr || '';
}

function maskCurrency(value: string) {
    if (!value || value === '') return '';

    // Remove tudo exceto números
    let numbers = value.replace(/\D/g, '');
    
    // Se não tem números, retorna vazio
    if (!numbers) return '';
    
    // Converte para número
    const num = parseInt(numbers, 10);
    
    // Formata como moeda brasileira (centavos para reais)
    const formatted = (num / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
    });
    
    return formatted;
}

function unmaskCurrency(value: string) {
    // Remove 'R$', espaços e pontos (separadores de milhares)
    // Mantém apenas números e vírgula decimal
    const cleaned = value.replace(/[R$\s\.]/g, '');
    
    // Se tem vírgula, converte para ponto decimal para armazenamento
    if (cleaned.includes(',')) {
        return cleaned.replace(',', '.');
    }
    
    return cleaned;
}

// Função para formatar número com separador de milhares
function maskThousands(value: string) {
    if (!value || value === '') return '';
    
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');
    
    // Se não tem números, retorna vazio
    if (!numbers) return '';
    
    // Converte para número e formata com separador de milhares
    const num = parseInt(numbers, 10);
    return num.toLocaleString('pt-BR');
}

// Função para remover máscara de milhares e retornar apenas números
function unmaskThousands(value: string) {
    if (!value) return '';
    return value.replace(/\D/g, '');
}

// Função para formatar valores que já vêm em reais (não em centavos)
function formatCurrencyFromReais(value: string | number) {
    if (!value || value === '') return '';
    
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) return '';
    
    return num.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
    });
}

// Função para formatar preço que já vem como decimal da API
function formatPriceFromAPI(value: string | number) {
    if (!value || value === '') return '';
    
    const num = typeof value === 'string' ? parseFloat(value) : value;
    
    if (isNaN(num)) return '';
    
    return num.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
    });
}

// Função para formatar preço durante a edição (sem reformatar automaticamente)
function formatPriceForEditing(value: string) {
    // Se já está formatado (tem R$), retorna como está
    if (value.includes('R$')) return value;
    
    // Se é um número válido, formata
    const num = parseFloat(value);
    if (!isNaN(num)) {
        return num.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
        });
    }
    
    return value;
}

// Função para validar entrada de preço durante digitação
function validatePriceInput(value: string) {
    // Remove caracteres não permitidos, mantendo apenas números, vírgula, ponto e R$
    return value.replace(/[^0-9,\.R$\s]/g, '');
}

// Função para remover máscara de preço por litro
function unmaskPricePerLiter(value: string) {
    if (!value || value === '') return '';
    
    // Remove 'R$', espaços e pontos (separadores de milhares)
    // Mantém apenas números e vírgula decimal
    let cleaned = value.replace(/[R$\s\.]/g, '');
    
    // Se tem vírgula, converte para ponto decimal
    if (cleaned.includes(',')) {
        cleaned = cleaned.replace(',', '.');
    }
    
    // Se é um valor válido, retorna diretamente (já está no formato correto)
    const num = parseFloat(cleaned);
    if (!isNaN(num)) {
        return num.toString();
    }
    
    return '';
}

// Função para unmask de valores formatados pela formatPriceFromAPI
function unmaskPriceFromAPI(value: string) {
    if (!value || value === '') return '';
    
    // Remove 'R$', espaços e pontos (separadores de milhares)
    let cleaned = value.replace(/[R$\s\.]/g, '');
    
    // Se tem vírgula, converte para ponto decimal
    if (cleaned.includes(',')) {
        cleaned = cleaned.replace(',', '.');
    }
    
    // Retorna o valor limpo (já está no formato decimal correto)
    return cleaned;
}

// Função para calcular o Giro Operacional
function calcularGiroOperacional(expectativaPB: string, precoLitro: string, prazoDias: string): string {
    if (!expectativaPB || !precoLitro || !prazoDias) return '';
    
    const expectativa = parseFloat(expectativaPB.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
    // O precoLitro já vem como string decimal da API (ex: "5.15")
    const preco = parseFloat(precoLitro) || 0;
    const prazo = parseFloat(prazoDias.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
    
    if (expectativa === 0 || preco === 0 || prazo === 0) return '';
    
    const giro = (expectativa / 30) * preco * prazo;
    
    // Formata o resultado com 4 casas decimais
    return giro.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 4,
        maximumFractionDigits: 4
    });
}

function normalizarPreco(
    precoAtual: any,
    novosValores: { Gasolina: string; Diesel: string; Diesel_S10: string; Etanol: string; Gas: string }
) {
    const precoNormalizado = { ...(precoAtual || {}) };

    precoNormalizado.Gasolina = parseFloat(novosValores.Gasolina) || 0;
    precoNormalizado.Diesel = parseFloat(novosValores.Diesel) || 0;
    precoNormalizado.Diesel_s10 = parseFloat(novosValores.Diesel_S10) || 0;
    precoNormalizado.Etanol = parseFloat(novosValores.Etanol) || 0;
    precoNormalizado.Gas = parseFloat(novosValores.Gas) || 0;

    delete precoNormalizado.gasolina;
    delete precoNormalizado.diesel;
    delete precoNormalizado.diesel_s10;
    delete precoNormalizado.etanol;
    delete precoNormalizado.gas;

    return precoNormalizado;
}


// Altere o fetchSumula para retornar o objeto completo, incluindo o jsonSumula parseado:
async function fetchSumula(id: string): Promise<any | null> {
    try {
        const config = {
            headers: headers(),
        };

        const response = await apiPetro.get<any>(`analise/obtersumula?id=${id}`, config);
        
        if (!response.data) return null;
        const result = response.data;
        
        // Parse o jsonSumula e coloque como propriedade do objeto principal
        if (result && result.jsonSumula) {
            result.sumulaData = JSON.parse(result.jsonSumula);
        }
        return result;
    } catch (err) {
        return null;
    }
}

export const SumulaPetrobahia = () => {
    const { id } = useParams<{ id: string }>();
    const [sumulaPetrobahia, setSumulaPetrobahia] = useState<SumulaObterResponse | null>(null);
    const [user, setUser] = useState<IUser | null>(null);
    
    // Determina se os botões devem ser escondidos para assessor em estado diferente de 0
    const shouldHideButtons = user?.perfil === 'Assessor' && sumulaPetrobahia?.estadoAtual !== 0;
    
    // States para campos extras dos dados cadastrais básicos
    const [codigoGrupo, setCodigoGrupo] = useState('');
    const [modalidade, setModalidade] = useState('Definitivo');
    const [conceito, setConceito] = useState('Excelente');
    const [limiteAtual, setLimiteAtual] = useState('');
    const [limiteProposto, setLimiteProposto] = useState('');
    const [conceitoCliente, setConceitoCliente] = useState('');
    const sumulaRef = useRef<HTMLDivElement>(null);

    // Estado para upload de documentos na súmula (um por vez)
    const [nomeNovoDocumento, setNomeNovoDocumento] = useState('');
    const [arquivoNovoDocumento, setArquivoNovoDocumento] = useState<File | null>(null);
    const [uploadDocumentoLoading, setUploadDocumentoLoading] = useState(false);
    const [uploadDocumentoError, setUploadDocumentoError] = useState<string | null>(null);

const handleDownloadSumulaCompleta = () => {
  if (!sumulaRef.current) {
    alert("Erro: não foi possível encontrar o conteúdo da súmula.");
    return;
  }

  // Clona o container da súmula
  const clone = sumulaRef.current.cloneNode(true) as HTMLElement;
  // Remove todos os botões SaveButton e ReturnButton
  clone.querySelectorAll('.SaveButton, .ReturnButton, button').forEach(el => el.remove());

  // Torna todos os campos não editáveis
  clone.querySelectorAll('input, textarea, select').forEach(el => {
    el.setAttribute('readonly', 'true');
    el.setAttribute('disabled', 'true');
  });

  // Captura o conteúdo do <head> (estilos e meta)
  const headContent = document.head.outerHTML;

  // Monta o HTML completo
  const finalHtml = `
    <!DOCTYPE html>
    <html>
      ${headContent}
      <body>
        ${clone.outerHTML}
      </body>
    </html>
  `;

  // Cria o Blob e o link para download
  const blob = new Blob([finalHtml], { type: 'text/html' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `sumula_completa.html`;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);

  alert('Download da súmula iniciado!');
};
    
    // States para Expectativa PB e Margem Litro
    const [expectativaPB, setExpectativaPB] = useState({
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: ''
    });
    const [margemLitro, setMargemLitro] = useState({
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: ''
    });
    
    // States para Expectativa PB e Margem Litro do Grupo Econômico
    const [grupoExpectativaPB, setGrupoExpectativaPB] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});
    const [grupoMargemLitro, setGrupoMargemLitro] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});
    
    // States para Prazo de Pagamento por combustível
    const [prazoPagamento, setPrazoPagamento] = useState({
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: ''
    });
    // Novo estado para tipo de pagamento (à vista/a prazo) do principal
    const [tipoPagamento, setTipoPagamento] = useState({
        Gasolina: 'A prazo',
        Diesel: 'A prazo',
        Diesel_S10: 'A prazo',
        Etanol: 'A prazo',
        Gas: 'A prazo'
    });
    
    // States para Prazo de Pagamento do Grupo Econômico
    const [grupoPrazoPagamento, setGrupoPrazoPagamento] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});
    // Novo estado para tipo de pagamento do grupo econômico
    const [grupoTipoPagamento, setGrupoTipoPagamento] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});
    
    // States para Preço por Litro por combustível
    const [precoLitro, setPrecoLitro] = useState({
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: ''
    });
    
    // States para valores de preço durante edição (para preservar cursor)
    const [precoLitroDisplay, setPrecoLitroDisplay] = useState({
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: ''
    });
    
    // States para Preço por Litro do Grupo Econômico
    const [grupoPrecoLitro, setGrupoPrecoLitro] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});

    // States para valores de preço do grupo durante edição
    const [grupoPrecoLitroDisplay, setGrupoPrecoLitroDisplay] = useState<{[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}}>({});

    // States para os pareceres
    const [parecerAssessor, setParecerAssessor] = useState('');
    const [parecerRiscos, setParecerRiscos] = useState('');
    const [parecerGerente, setParecerGerente] = useState('');
    const [parecerCoordenacao, setParecerCoordenacao] = useState('');
    const [isLoading, setIsLoading] = useState(false); // Novo estado de loading
    const [error, setError] = useState<string | null>(null);

    // States para decisão escalão deferidor/diretoria
    const [decisao, setDecisao] = useState('');
    const [condicionantes, setCondicionantes] = useState('');
    const [limiteCredito, setLimiteCredito] = useState('');
    const [prazoDeferido, setPrazoDeferido] = useState('');

    const data: SumulaModel | undefined = sumulaPetrobahia?.sumulaData;

    // useEffect dedicado ao carregamento do usuário
    useEffect(() => {
        const sessionUser = getSessionUser();
        if (sessionUser) {
            setUser(sessionUser);
            console.log('Usuário definido:', sessionUser);
        } else {
            console.log('Nenhum usuário encontrado na sessão');
        }
    }, []); // Executa apenas uma vez ao montar o componente

    // useEffect consolidado para otimizar performance e evitar bugs
    useEffect(() => {
        // Carrega súmula quando ID muda
        if (id && !sumulaPetrobahia) {
            fetchSumula(id).then(setSumulaPetrobahia);
            return;
        }

        // Inicializa dados quando a súmula carrega
        if (data) {
            // Inicializa pareceres
            if (data.Pareceres) {
                const pareceres = data.Pareceres;
                setParecerAssessor(pareceres.ParecerAssessor || '');
                setParecerRiscos(pareceres.ParecerRiscos || '');
                setParecerGerente(pareceres.ParecerGerente || '');
                setParecerCoordenacao(pareceres.ParecerCoordenacao || '');
            } else {
                setParecerAssessor('');
                setParecerRiscos('');
                setParecerGerente('');
                setParecerCoordenacao('');
            }

            // Inicializa campos editáveis básicos
            setCodigoGrupo(data.CodigoGrupo || '');
            setLimiteProposto(data.LimiteProposto?.toString() || '');
            setConceitoCliente(data.ConceitoCliente || '');
            
            // Inicializa Expectativa PB e Margem Litro
            if (data.ExpectativaConsumo) {
                setExpectativaPB({
                    Gasolina: data.ExpectativaConsumo.PB_Gasolina || '',
                    Diesel: data.ExpectativaConsumo.PB_Diesel || '',
                    Diesel_S10: data.ExpectativaConsumo.PB_Diesel_S10 || '',
                    Etanol: data.ExpectativaConsumo.PB_Etanol || '',
                    Gas: data.ExpectativaConsumo.PB_Gas || ''
                });
                setMargemLitro({
                    Gasolina: data.ExpectativaConsumo.Margem_Gasolina || '',
                    Diesel: data.ExpectativaConsumo.Margem_Diesel || '',
                    Diesel_S10: data.ExpectativaConsumo.Margem_Diesel_S10 || '',
                    Etanol: data.ExpectativaConsumo.Margem_Etanol || '',
                    Gas: data.ExpectativaConsumo.Margem_Gas || ''
                });
            }
            
            // Inicializa Prazo de Pagamento por combustível
            setPrazoPagamento({
                Gasolina: (data.ExpectativaConsumo as any)?.Prazo_Gasolina || data.PrazoPagamento?.toString() || '',
                Diesel: (data.ExpectativaConsumo as any)?.Prazo_Diesel || data.PrazoPagamento?.toString() || '',
                Diesel_S10: (data.ExpectativaConsumo as any)?.Prazo_Diesel_S10 || data.PrazoPagamento?.toString() || '',
                Etanol: (data.ExpectativaConsumo as any)?.Prazo_Etanol || data.PrazoPagamento?.toString() || '',
                Gas: (data.ExpectativaConsumo as any)?.Prazo_Gas || data.PrazoPagamento?.toString() || ''
            });
            
            // Inicializa Preço por Litro por combustível
            const newPrecoLitro = {
                Gasolina: (data.Preco as any)?.Gasolina ? (data.Preco as any).Gasolina.toString() : (data.Preco?.gasolina ? data.Preco.gasolina.toString() : ''),
                Diesel: (data.Preco as any)?.Diesel ? (data.Preco as any).Diesel.toString() : (data.Preco?.diesel ? data.Preco.diesel.toString() : ''),
                Diesel_S10: (data.Preco as any)?.Diesel_s10 ? (data.Preco as any).Diesel_s10.toString() : (data.Preco?.diesel_s10 ? data.Preco.diesel_s10.toString() : ''),
                Etanol: (data.Preco as any)?.Etanol ? (data.Preco as any).Etanol.toString() : (data.Preco?.etanol ? data.Preco.etanol.toString() : ''),
                Gas: (data.Preco as any)?.Gas ? (data.Preco as any).Gas.toString() : (data.Preco?.gas ? data.Preco.gas.toString() : '')
            };
            setPrecoLitro(newPrecoLitro);
            
            // Atualiza display de preços simultaneamente
            setPrecoLitroDisplay({
                Gasolina: newPrecoLitro.Gasolina ? formatPriceFromAPI(newPrecoLitro.Gasolina) : '',
                Diesel: newPrecoLitro.Diesel ? formatPriceFromAPI(newPrecoLitro.Diesel) : '',
                Diesel_S10: newPrecoLitro.Diesel_S10 ? formatPriceFromAPI(newPrecoLitro.Diesel_S10) : '',
                Etanol: newPrecoLitro.Etanol ? formatPriceFromAPI(newPrecoLitro.Etanol) : '',
                Gas: newPrecoLitro.Gas ? formatPriceFromAPI(newPrecoLitro.Gas) : ''
            });
            
            // Inicializa dados do Grupo Econômico
            if (data.GrupoEconomico && data.GrupoEconomico.length > 0) {
                const grupoExpPB: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
                const grupoMargem: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
                const grupoPrazo: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
                const grupoPreco: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
                const newGrupoDisplay: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
                
                data.GrupoEconomico.forEach((grupo, index) => {
                    grupoExpPB[index] = {
                        Gasolina: grupo.ExpectativaConsumo?.PB_Gasolina || '',
                        Diesel: grupo.ExpectativaConsumo?.PB_Diesel || '',
                        Diesel_S10: grupo.ExpectativaConsumo?.PB_Diesel_S10 || '',
                        Etanol: grupo.ExpectativaConsumo?.PB_Etanol || '',
                        Gas: grupo.ExpectativaConsumo?.PB_Gas || ''
                    };
                    grupoMargem[index] = {
                        Gasolina: grupo.ExpectativaConsumo?.Margem_Gasolina || '',
                        Diesel: grupo.ExpectativaConsumo?.Margem_Diesel || '',
                        Diesel_S10: grupo.ExpectativaConsumo?.Margem_Diesel_S10 || '',
                        Etanol: grupo.ExpectativaConsumo?.Margem_Etanol || '',
                        Gas: grupo.ExpectativaConsumo?.Margem_Gas || ''
                    };
                    grupoPrazo[index] = {
                        Gasolina: (grupo.ExpectativaConsumo as any)?.Prazo_Gasolina || grupo.PrazoPagamento?.toString() || '',
                        Diesel: (grupo.ExpectativaConsumo as any)?.Prazo_Diesel || grupo.PrazoPagamento?.toString() || '',
                        Diesel_S10: (grupo.ExpectativaConsumo as any)?.Prazo_Diesel_S10 || grupo.PrazoPagamento?.toString() || '',
                        Etanol: (grupo.ExpectativaConsumo as any)?.Prazo_Etanol || grupo.PrazoPagamento?.toString() || '',
                        Gas: (grupo.ExpectativaConsumo as any)?.Prazo_Gas || grupo.PrazoPagamento?.toString() || ''
                    };
                    grupoPreco[index] = {
                        Gasolina: (grupo.Preco as any)?.Gasolina ? (grupo.Preco as any).Gasolina.toString() : (grupo.Preco?.gasolina ? (grupo.Preco.gasolina * 100).toString() : ''),
                        Diesel: (grupo.Preco as any)?.Diesel ? (grupo.Preco as any).Diesel.toString() : (grupo.Preco?.diesel ? (grupo.Preco.diesel * 100).toString() : ''),
                        Diesel_S10: (grupo.Preco as any)?.Diesel_s10 ? (grupo.Preco as any).Diesel_s10.toString() : (grupo.Preco?.diesel_s10 ? (grupo.Preco.diesel_s10 * 100).toString() : ''),
                        Etanol: (grupo.Preco as any)?.Etanol ? (grupo.Preco as any).Etanol.toString() : (grupo.Preco?.etanol ? (grupo.Preco.etanol * 100).toString() : ''),
                        Gas: (grupo.Preco as any)?.Gas ? (grupo.Preco as any).Gas.toString() : (grupo.Preco?.gas ? (grupo.Preco.gas * 100).toString() : '')
                    };
                    
                    // Atualiza display do grupo simultaneamente
                    newGrupoDisplay[index] = {
                        Gasolina: grupoPreco[index]?.Gasolina ? formatPriceFromAPI(grupoPreco[index].Gasolina) : '',
                        Diesel: grupoPreco[index]?.Diesel ? formatPriceFromAPI(grupoPreco[index].Diesel) : '',
                        Diesel_S10: grupoPreco[index]?.Diesel_S10 ? formatPriceFromAPI(grupoPreco[index].Diesel_S10) : '',
                        Etanol: grupoPreco[index]?.Etanol ? formatPriceFromAPI(grupoPreco[index].Etanol) : '',
                        Gas: grupoPreco[index]?.Gas ? formatPriceFromAPI(grupoPreco[index].Gas) : ''
                    };
                });
                
                setGrupoExpectativaPB(grupoExpPB);
                setGrupoMargemLitro(grupoMargem);
                setGrupoPrazoPagamento(grupoPrazo);
                setGrupoPrecoLitro(grupoPreco);
                setGrupoPrecoLitroDisplay(newGrupoDisplay);
            }
            
            // Inicializa dados da Decisão da Diretoria
            if (data.DecisaoDiretoria) {
                const decisaoDiretoria = data.DecisaoDiretoria;
                setDecisao(decisaoDiretoria.decisao || '');
                setCondicionantes(decisaoDiretoria.condicionantes || '');
                setLimiteCredito(decisaoDiretoria.limiteCredito || '');
                setPrazoDeferido(decisaoDiretoria.prazoDeferido || '');
            }
        }
    }, [id, data]);

    // useEffect separado apenas para atualizações de preço durante edição
    useEffect(() => {
        if (precoLitro.Gasolina || precoLitro.Diesel || precoLitro.Diesel_S10 || precoLitro.Etanol) {
            setPrecoLitroDisplay({
                Gasolina: precoLitro.Gasolina ? formatPriceFromAPI(precoLitro.Gasolina) : '',
                Diesel: precoLitro.Diesel ? formatPriceFromAPI(precoLitro.Diesel) : '',
                Diesel_S10: precoLitro.Diesel_S10 ? formatPriceFromAPI(precoLitro.Diesel_S10) : '',
                Etanol: precoLitro.Etanol ? formatPriceFromAPI(precoLitro.Etanol) : '',
                Gas: precoLitro.Gas ? formatPriceFromAPI(precoLitro.Gas) : ''
            });
        }
    }, [precoLitro]);


    // useEffect separado para atualizações de preço do grupo durante edição
    useEffect(() => {
        if (Object.keys(grupoPrecoLitro).length > 0) {
            const newGrupoDisplay: {[key: number]: {Gasolina: string, Diesel: string, Diesel_S10: string, Etanol: string, Gas: string}} = {};
            Object.keys(grupoPrecoLitro).forEach(key => {
                const index = parseInt(key);
                newGrupoDisplay[index] = {
                    Gasolina: grupoPrecoLitro[index]?.Gasolina ? formatPriceFromAPI(grupoPrecoLitro[index].Gasolina) : '',
                    Diesel: grupoPrecoLitro[index]?.Diesel ? formatPriceFromAPI(grupoPrecoLitro[index].Diesel) : '',
                    Diesel_S10: grupoPrecoLitro[index]?.Diesel_S10 ? formatPriceFromAPI(grupoPrecoLitro[index].Diesel_S10) : '',
                    Etanol: grupoPrecoLitro[index]?.Etanol ? formatPriceFromAPI(grupoPrecoLitro[index].Etanol) : '',
                    Gas: grupoPrecoLitro[index]?.Gas ? formatPriceFromAPI(grupoPrecoLitro[index].Gas) : ''
                };
            });
            setGrupoPrecoLitroDisplay(newGrupoDisplay);
        }
    }, [grupoPrecoLitro]);

    if (!sumulaPetrobahia || !data) return <div>Carregando...</div>;
    const dataDefined: SumulaModel = data;

    // Simulação de salvar (pode ser adaptado para API)
 const handleSave = async (parecer: string, tipo: string, aprovado: boolean = true) => {
    if (!dataDefined) return;
        setIsLoading(true); // Ativa o indicador de carregamento
        setError(null);     // Limpa qualquer mensagem de erro anterior

        

        // Atualiza o campo de parecer correspondente na model
        const updatedData = { ...dataDefined };
        
        // Atualiza os campos editáveis
        updatedData.CodigoGrupo = codigoGrupo;
        updatedData.LimiteProposto = limiteProposto;
        updatedData.ConceitoCliente = conceitoCliente;
        
        // Atualiza Expectativa PB e Margem Litro
        if (!updatedData.ExpectativaConsumo) {
            updatedData.ExpectativaConsumo = {
                Gasolina: '',
                Diesel: '',
                Diesel_S10: '',
                Etanol: '',
                Gas: '',
                PB_Gasolina: '',
                PB_Diesel: '',
                PB_Diesel_S10: '',
                PB_Etanol: '',
                PB_Gas: '',
                Margem_Gasolina: '',
                Margem_Diesel: '',
                Margem_Diesel_S10: '',
                Margem_Etanol: '',
                Margem_Gas: '',
                Preco_Gasolina: '',
                Preco_Diesel: '',
                Preco_Diesel_S10: '',
                Preco_Etanol: '',
                Giro_Gasolina: '',
                Giro_Diesel: '',
                Giro_Diesel_S10: '',
                Giro_Etanol: '',
                Giro_Gas: ''
            };
        }
        updatedData.ExpectativaConsumo.PB_Gasolina = expectativaPB.Gasolina;
        updatedData.ExpectativaConsumo.PB_Diesel = expectativaPB.Diesel;
        updatedData.ExpectativaConsumo.PB_Diesel_S10 = expectativaPB.Diesel_S10;
        updatedData.ExpectativaConsumo.PB_Etanol = expectativaPB.Etanol;
        updatedData.ExpectativaConsumo.PB_Gas = expectativaPB.Gas;
        updatedData.ExpectativaConsumo.Margem_Gasolina = margemLitro.Gasolina;
        updatedData.ExpectativaConsumo.Margem_Diesel = margemLitro.Diesel;
        updatedData.ExpectativaConsumo.Margem_Diesel_S10 = margemLitro.Diesel_S10;
        updatedData.ExpectativaConsumo.Margem_Etanol = margemLitro.Etanol;
        updatedData.ExpectativaConsumo.Margem_Gas = margemLitro.Gas;
        
        // Atualiza Prazos de Pagamento por combustível (usando type assertion)
        (updatedData.ExpectativaConsumo as any).Prazo_Gasolina = prazoPagamento.Gasolina;
        (updatedData.ExpectativaConsumo as any).Prazo_Diesel = prazoPagamento.Diesel;
        (updatedData.ExpectativaConsumo as any).Prazo_Diesel_S10 = prazoPagamento.Diesel_S10;
        (updatedData.ExpectativaConsumo as any).Prazo_Etanol = prazoPagamento.Etanol;
        (updatedData.ExpectativaConsumo as any).Prazo_Gas = prazoPagamento.Gas;
        
        // Atualiza Preços por combustível
        updatedData.Preco = normalizarPreco(updatedData.Preco, precoLitro);
        
        // Atualiza dados do Grupo Econômico
        if (updatedData.GrupoEconomico) {
            updatedData.GrupoEconomico.forEach((grupo, index) => {
                if (!grupo.ExpectativaConsumo) {
                    grupo.ExpectativaConsumo = {
                        Gasolina: '',
                        Diesel: '',
                        Diesel_S10: '',
                        Etanol: '',
                        Gas: '',
                        PB_Gasolina: '',
                        PB_Diesel: '',
                        PB_Diesel_S10: '',
                        PB_Etanol: '',
                        PB_Gas: '',
                        Margem_Gasolina: '',
                        Margem_Diesel: '',
                        Margem_Diesel_S10: '',
                        Margem_Etanol: '',
                        Margem_Gas: '',
                    };
                }
                
                if (grupoExpectativaPB[index]) {
                    grupo.ExpectativaConsumo.PB_Gasolina = grupoExpectativaPB[index].Gasolina;
                    grupo.ExpectativaConsumo.PB_Diesel = grupoExpectativaPB[index].Diesel;
                    grupo.ExpectativaConsumo.PB_Diesel_S10 = grupoExpectativaPB[index].Diesel_S10;
                    grupo.ExpectativaConsumo.PB_Etanol = grupoExpectativaPB[index].Etanol;
                    grupo.ExpectativaConsumo.PB_Gas = grupoExpectativaPB[index].Gas;
                }
                
                if (grupoMargemLitro[index]) {
                    grupo.ExpectativaConsumo.Margem_Gasolina = grupoMargemLitro[index].Gasolina;
                    grupo.ExpectativaConsumo.Margem_Diesel = grupoMargemLitro[index].Diesel;
                    grupo.ExpectativaConsumo.Margem_Diesel_S10 = grupoMargemLitro[index].Diesel_S10;
                    grupo.ExpectativaConsumo.Margem_Etanol = grupoMargemLitro[index].Etanol;
                    grupo.ExpectativaConsumo.Margem_Gas = grupoMargemLitro[index].Gas;
                }
                
                // Atualiza Prazos de Pagamento do Grupo Econômico (usando type assertion)
                if (grupoPrazoPagamento[index]) {
                    (grupo.ExpectativaConsumo as any).Prazo_Gasolina = grupoPrazoPagamento[index].Gasolina;
                    (grupo.ExpectativaConsumo as any).Prazo_Diesel = grupoPrazoPagamento[index].Diesel;
                    (grupo.ExpectativaConsumo as any).Prazo_Diesel_S10 = grupoPrazoPagamento[index].Diesel_S10;
                    (grupo.ExpectativaConsumo as any).Prazo_Etanol = grupoPrazoPagamento[index].Etanol;
                    (grupo.ExpectativaConsumo as any).Prazo_Gas = grupoPrazoPagamento[index].Gas;
                }
                
                // Atualiza Preços do Grupo Econômico
                if (grupoPrecoLitro[index]) {
                    grupo.Preco = normalizarPreco(grupo.Preco, grupoPrecoLitro[index]);
                }
            });
        }
        
        if (!updatedData.Pareceres) {
            updatedData.Pareceres = {
                ParecerAssessor: '',
                ParecerRiscos: '',
                ParecerGerente: '',
                ParecerCoordenacao: ''
            };
        }
        if (tipo === 'Assessor Comercial') updatedData.Pareceres.ParecerAssessor = parecer;
        if (tipo === 'Gestão de Riscos') updatedData.Pareceres.ParecerRiscos = parecer;
        if (tipo === 'Gerente de Negócios') updatedData.Pareceres.ParecerGerente = parecer;
        if (tipo === 'Coordenação de Riscos') updatedData.Pareceres.ParecerCoordenacao = parecer;

        // Monta o objeto para o PUT
        const payload = {
            id: id,
            codigoGrupo: updatedData.CodigoGrupo ?? '',
            nomeGrupo: updatedData.NomeGrupoEconomico ?? '',
            codigoCliente: sumulaPetrobahia.codigoCliente ?? '',
            versaoSumula: sumulaPetrobahia.VersaoSumula ?? sumulaPetrobahia.versaoSumula,
            dataCriacao: new Date().toISOString(),
            usuarioCriacao: sumulaPetrobahia.usuarioCriacao ?? '',
            jsonSumula: JSON.stringify(updatedData),
            statusSumula: sumulaPetrobahia.statusSumula, // Corrigido para o nome correto
            aprovado: aprovado,
            estadoAtual: sumulaPetrobahia.estadoAtual,
        };

        try {
            const config = {
                headers: {
                    ...headers(),
                    'Content-Type': 'application/json'
                },
            };
            console.log(sumulaPetrobahia.statusSumula);
            
            const response = await apiPetro.put('analise/atualizarsumula', payload, config);
            
            if (response.status === 200) {
                const acao = aprovado ? 'aprovado' : 'retornado';
                alert(`Parecer "${tipo}" ${acao} com sucesso!`);
                if (id) {
                const freshSumula = await fetchSumula(id);
                if (freshSumula) {
                    setSumulaPetrobahia(freshSumula);
                }
            }
            } else {
                alert('Erro ao salvar parecer.');
            }
        } catch (err) {
            alert('Erro de conexão ao salvar parecer.');
        }
        finally{
            setIsLoading(false);
        }
    };

    const handleSaveDecisao = () => {
         alert(`Decisão salva:\nDecisão: ${decisao}\nCondicionantes: ${condicionantes}\nLimite de Crédito: ${limiteCredito}\nPrazo Deferido: ${prazoDeferido} dias`);
         };

    const handleSaveFields = async () => {
        if (!dataDefined) return;
        setIsLoading(true);
        
        try {
            // Atualiza apenas os campos editáveis
            const updatedData = { ...dataDefined };
            updatedData.CodigoGrupo = codigoGrupo;
            updatedData.LimiteProposto = limiteProposto;
            updatedData.ConceitoCliente = conceitoCliente;
            
            // Atualiza Expectativa PB e Margem Litro
            if (!updatedData.ExpectativaConsumo) {
                updatedData.ExpectativaConsumo = {
                    Gasolina: '',
                    Diesel: '',
                    Diesel_S10: '',
                    Etanol: '',
                    Gas: '',
                    PB_Gasolina: '',
                    PB_Diesel: '',
                    PB_Diesel_S10: '',
                    PB_Etanol: '',
                    PB_Gas: '',
                    Margem_Gasolina: '',
                    Margem_Diesel: '',
                    Margem_Diesel_S10: '',
                    Margem_Etanol: '',
                    Margem_Gas: '',
                    Preco_Gasolina: '',
                    Preco_Diesel: '',
                    Preco_Diesel_S10: '',
                    Preco_Etanol: '',
                    Preco_Gas: '',
                    Giro_Gasolina: '',
                    Giro_Diesel: '',
                    Giro_Diesel_S10: '',
                    Giro_Etanol: '',
                    Giro_Gas: ''
                };
            }
            updatedData.ExpectativaConsumo.PB_Gasolina = expectativaPB.Gasolina;
            updatedData.ExpectativaConsumo.PB_Diesel = expectativaPB.Diesel;
            updatedData.ExpectativaConsumo.PB_Diesel_S10 = expectativaPB.Diesel_S10;
            updatedData.ExpectativaConsumo.PB_Etanol = expectativaPB.Etanol;
            updatedData.ExpectativaConsumo.PB_Gas = expectativaPB.Gas;
            updatedData.ExpectativaConsumo.Margem_Gasolina = margemLitro.Gasolina;
            updatedData.ExpectativaConsumo.Margem_Diesel = margemLitro.Diesel;
            updatedData.ExpectativaConsumo.Margem_Diesel_S10 = margemLitro.Diesel_S10;
            updatedData.ExpectativaConsumo.Margem_Etanol = margemLitro.Etanol;
            updatedData.ExpectativaConsumo.Margem_Gas = margemLitro.Gas;
            
            // Atualiza Prazos de Pagamento por combustível (usando type assertion)
            (updatedData.ExpectativaConsumo as any).Prazo_Gasolina = prazoPagamento.Gasolina;
            (updatedData.ExpectativaConsumo as any).Prazo_Diesel = prazoPagamento.Diesel;
            (updatedData.ExpectativaConsumo as any).Prazo_Diesel_S10 = prazoPagamento.Diesel_S10;
            (updatedData.ExpectativaConsumo as any).Prazo_Etanol = prazoPagamento.Etanol;
            (updatedData.ExpectativaConsumo as any).Prazo_Gas = prazoPagamento.Gas;
            
            // Atualiza Preços por Litro
            updatedData.Preco = normalizarPreco(updatedData.Preco, precoLitro);

            // Atualiza dados do Grupo Econômico
            if (updatedData.GrupoEconomico) {
                updatedData.GrupoEconomico.forEach((grupo, index) => {
                    if (!grupo.ExpectativaConsumo) {
                        grupo.ExpectativaConsumo = {
                            Gasolina: '',
                            Diesel: '',
                            Diesel_S10: '',
                            Etanol: '',
                            Gas: '',
                            PB_Gasolina: '',
                            PB_Diesel: '',
                            PB_Diesel_S10: '',
                            PB_Etanol: '',
                            PB_Gas: '',
                            Margem_Gasolina: '',
                            Margem_Diesel: '',
                            Margem_Diesel_S10: '',
                            Margem_Etanol: '',
                            Margem_Gas: '',
                        };
                    }
                    
                    if (grupoExpectativaPB[index]) {
                        grupo.ExpectativaConsumo.PB_Gasolina = grupoExpectativaPB[index].Gasolina;
                        grupo.ExpectativaConsumo.PB_Diesel = grupoExpectativaPB[index].Diesel;
                        grupo.ExpectativaConsumo.PB_Diesel_S10 = grupoExpectativaPB[index].Diesel_S10;
                        grupo.ExpectativaConsumo.PB_Etanol = grupoExpectativaPB[index].Etanol;
                        grupo.ExpectativaConsumo.PB_Gas = grupoExpectativaPB[index].Gas;
                    }
                    
                    if (grupoMargemLitro[index]) {
                        grupo.ExpectativaConsumo.Margem_Gasolina = grupoMargemLitro[index].Gasolina;
                        grupo.ExpectativaConsumo.Margem_Diesel = grupoMargemLitro[index].Diesel;
                        grupo.ExpectativaConsumo.Margem_Diesel_S10 = grupoMargemLitro[index].Diesel_S10;
                        grupo.ExpectativaConsumo.Margem_Etanol = grupoMargemLitro[index].Etanol;
                        grupo.ExpectativaConsumo.Margem_Gas = grupoMargemLitro[index].Gas;
                    }
                    
                    // Atualiza Prazos de Pagamento do Grupo Econômico (usando type assertion)
                    if (grupoPrazoPagamento[index]) {
                        (grupo.ExpectativaConsumo as any).Prazo_Gasolina = grupoPrazoPagamento[index].Gasolina;
                        (grupo.ExpectativaConsumo as any).Prazo_Diesel = grupoPrazoPagamento[index].Diesel;
                        (grupo.ExpectativaConsumo as any).Prazo_Diesel_S10 = grupoPrazoPagamento[index].Diesel_S10;
                        (grupo.ExpectativaConsumo as any).Prazo_Etanol = grupoPrazoPagamento[index].Etanol;
                        (grupo.ExpectativaConsumo as any).Prazo_Gas = grupoPrazoPagamento[index].Gas;
                    }
                    
                    // Atualiza Preços do Grupo Econômico
                    if (grupoPrecoLitro[index]) {
                        grupo.Preco = normalizarPreco(grupo.Preco, grupoPrecoLitro[index]);
                    }
                });
            }

            const payload = {
                id: id,
                codigoGrupo: codigoGrupo,
                nomeGrupo: updatedData.NomeGrupoEconomico ?? '',
                codigoCliente: sumulaPetrobahia.codigoCliente ?? '',
                versaoSumula: sumulaPetrobahia.VersaoSumula ?? sumulaPetrobahia.versaoSumula,
                dataCriacao: new Date().toISOString(),
                usuarioCriacao: sumulaPetrobahia.usuarioCriacao ?? '',
                jsonSumula: JSON.stringify(updatedData),
                statusSumula:sumulaPetrobahia.statusSumula,
                aprovado: true,

            };

            const config = {
                headers: {
                    ...headers(),
                    'Content-Type': 'application/json'
                },
            };
            console.log('Payload enviado:', payload);
            
            const response = await apiPetro.put('analise/atualizarsumula', payload, config);
            
            if (response.status === 200) {
                alert('Dados salvos com sucesso!');
            } else {
                alert('Erro ao salvar dados.');
            }
        } catch (err) {
            alert('Erro de conexão ao salvar dados.');
        } finally {
            setIsLoading(false);
        }
    };

const handleDraftSave = async () => {
    if (!dataDefined) return;
    setIsLoading(true);
    setError(null);

    const updatedData = { ...dataDefined };

        updatedData.CodigoGrupo = codigoGrupo;
        updatedData.LimiteProposto = limiteProposto;
        updatedData.ConceitoCliente = conceitoCliente;
        updatedData.Pareceres = {
            ParecerAssessor: parecerAssessor ?? '',
            ParecerRiscos: parecerRiscos ?? '',
            ParecerGerente: updatedData.Pareceres?.ParecerGerente ?? '',
            ParecerCoordenacao: parecerCoordenacao ?? '',
        };
    
    if (!updatedData.ExpectativaConsumo) {
        updatedData.ExpectativaConsumo = {
        Gasolina: '',
        Diesel: '',
        Diesel_S10: '',
        Etanol: '',
        Gas: '',
        PB_Gasolina: '',
        PB_Diesel: '',
        PB_Diesel_S10: '',
        PB_Etanol: '',
        PB_Gas: '',
        Margem_Gasolina: '',
        Margem_Diesel: '',
        Margem_Diesel_S10: '',
        Margem_Etanol: '',
        Margem_Gas: '',
        Preco_Gasolina: '',
        Preco_Diesel: '',
        Preco_Diesel_S10: '',
        Preco_Etanol: '',
        Giro_Gasolina: '',
        Giro_Diesel: '',
        Giro_Diesel_S10: '',
        Giro_Etanol: '',
        Giro_Gas: '',
        };
    }
    updatedData.ExpectativaConsumo.PB_Gasolina = expectativaPB.Gasolina;
    updatedData.ExpectativaConsumo.PB_Diesel = expectativaPB.Diesel;
    updatedData.ExpectativaConsumo.PB_Diesel_S10 = expectativaPB.Diesel_S10;
    updatedData.ExpectativaConsumo.PB_Etanol = expectativaPB.Etanol;
    updatedData.ExpectativaConsumo.PB_Gas = expectativaPB.Gas;
    updatedData.ExpectativaConsumo.Margem_Gasolina = margemLitro.Gasolina;
    updatedData.ExpectativaConsumo.Margem_Diesel = margemLitro.Diesel;
    updatedData.ExpectativaConsumo.Margem_Diesel_S10 = margemLitro.Diesel_S10;
    updatedData.ExpectativaConsumo.Margem_Etanol = margemLitro.Etanol;
    updatedData.ExpectativaConsumo.Margem_Gas = margemLitro.Gas;
    (updatedData.ExpectativaConsumo as any).Prazo_Gasolina = prazoPagamento.Gasolina;
    (updatedData.ExpectativaConsumo as any).Prazo_Diesel = prazoPagamento.Diesel;
    (updatedData.ExpectativaConsumo as any).Prazo_Diesel_S10 = prazoPagamento.Diesel_S10;
    (updatedData.ExpectativaConsumo as any).Prazo_Etanol = prazoPagamento.Etanol;
    (updatedData.ExpectativaConsumo as any).Prazo_Gas = prazoPagamento.Gas;

    updatedData.Preco = normalizarPreco(updatedData.Preco, precoLitro);

    if (updatedData.GrupoEconomico) {
        updatedData.GrupoEconomico.forEach((grupo, index) => {
        if (!grupo.ExpectativaConsumo) {
            grupo.ExpectativaConsumo = {
            Gasolina: '',
            Diesel: '',
            Diesel_S10: '',
            Etanol: '',
            Gas: '',
            PB_Gasolina: '',
            PB_Diesel: '',
            PB_Diesel_S10: '',
            PB_Etanol: '',
            PB_Gas: '',
            Margem_Gasolina: '',
            Margem_Diesel: '',
            Margem_Diesel_S10: '',
            Margem_Etanol: '',
            Margem_Gas: '',
            };
        }
        if (grupoExpectativaPB[index]) {
            grupo.ExpectativaConsumo.PB_Gasolina = grupoExpectativaPB[index].Gasolina;
            grupo.ExpectativaConsumo.PB_Diesel = grupoExpectativaPB[index].Diesel;
            grupo.ExpectativaConsumo.PB_Diesel_S10 = grupoExpectativaPB[index].Diesel_S10;
            grupo.ExpectativaConsumo.PB_Etanol = grupoExpectativaPB[index].Etanol;
            grupo.ExpectativaConsumo.PB_Gas = grupoExpectativaPB[index].Gas;
        }
        if (grupoMargemLitro[index]) {
            grupo.ExpectativaConsumo.Margem_Gasolina = grupoMargemLitro[index].Gasolina;
            grupo.ExpectativaConsumo.Margem_Diesel = grupoMargemLitro[index].Diesel;
            grupo.ExpectativaConsumo.Margem_Diesel_S10 = grupoMargemLitro[index].Diesel_S10;
            grupo.ExpectativaConsumo.Margem_Etanol = grupoMargemLitro[index].Etanol;
            grupo.ExpectativaConsumo.Margem_Gas = grupoMargemLitro[index].Gas;
        }
        if (grupoPrazoPagamento[index]) {
            (grupo.ExpectativaConsumo as any).Prazo_Gasolina = grupoPrazoPagamento[index].Gasolina;
            (grupo.ExpectativaConsumo as any).Prazo_Diesel = grupoPrazoPagamento[index].Diesel;
            (grupo.ExpectativaConsumo as any).Prazo_Diesel_S10 = grupoPrazoPagamento[index].Diesel_S10;
            (grupo.ExpectativaConsumo as any).Prazo_Etanol = grupoPrazoPagamento[index].Etanol;
            (grupo.ExpectativaConsumo as any).Prazo_Gas = grupoPrazoPagamento[index].Gas;
        }
        if (grupoPrecoLitro[index]) {
            grupo.Preco = normalizarPreco(grupo.Preco, grupoPrecoLitro[index]);
        }
        });
    }


    const payload = {
        id: id,
        codigoGrupo: updatedData.CodigoGrupo ?? '',
        nomeGrupo: updatedData.NomeGrupoEconomico ?? '',
        codigoCliente: sumulaPetrobahia.codigoCliente ?? '',
        versaoSumula: sumulaPetrobahia.VersaoSumula ?? sumulaPetrobahia.versaoSumula,
        dataCriacao: new Date().toISOString(),
        usuarioCriacao: sumulaPetrobahia.usuarioCriacao ?? '',
        jsonSumula: JSON.stringify(updatedData),
        statusSumula: sumulaPetrobahia.statusSumula, 
        aprovado: sumulaPetrobahia.aprovado, 
        estadoAtual: sumulaPetrobahia.estadoAtual, 
    };

    try {
        const config = {
        headers: {
            ...headers(),
            'Content-Type': 'application/json',
        },
        };

        const response = await apiPetro.put('analise/atualizarsumula?salvar=true', payload, config);

        if (response.status === 200) {
        alert('Alterações salvas com sucesso!');
        if (id) {
            const freshSumula = await fetchSumula(id);
            if (freshSumula) {
            setSumulaPetrobahia(freshSumula);
            }
        }
        } else {
        alert('Erro ao salvar as alterações.');
        }
    } catch (err) {
        alert('Erro de conexão ao salvar as alterações.');
    } finally {
        setIsLoading(false);
    }
};

const handleUpdateStatus = async (novoStatus: number, novoEstado: number) => {
  if (!dataDefined) return;
  setIsLoading(true);

  try {
    // Atualiza o status no objeto de dados
    const updatedData = { ...dataDefined };
    // (Opcional: atualize outros campos se necessário)

    // Monta o payload igual ao handleSaveFields, mas com o novo status e estado
    const payload = {
      id: id,
      codigoGrupo: updatedData.CodigoGrupo ?? '',
      nomeGrupo: updatedData.NomeGrupoEconomico ?? '',
      codigoCliente: sumulaPetrobahia.codigoCliente ?? '',
      versaoSumula: sumulaPetrobahia.VersaoSumula ?? sumulaPetrobahia.versaoSumula,
      dataCriacao: new Date().toISOString(),
      usuarioCriacao: sumulaPetrobahia.usuarioCriacao ?? '',
      jsonSumula: JSON.stringify(updatedData),
      statusSumula: novoStatus,
      aprovado: sumulaPetrobahia.aprovado,
      estadoAtual: novoEstado,
    };

    const config = {
      headers: {
        ...headers(),
        'Content-Type': 'application/json',
      },
    };

    const response = await apiPetro.put('analise/atualizarsumula?salvar=true', payload, config);

    if (response.status === 200) {
      alert('Status atualizado com sucesso!');
      if (id) {
        const freshSumula = await fetchSumula(id);
        if (freshSumula) {
          setSumulaPetrobahia(freshSumula);
        }
      }
    } else {
      alert('Erro ao atualizar status.');
    }
  } catch (err) {
    alert('Erro de conexão ao atualizar status.');
  } finally {
    setIsLoading(false);
  }
};

    /** Upload de um documento na súmula: envia para a API, adiciona o link em UrlDocumentos e atualiza a súmula. */
    const handleUploadDocumentoSumula = async () => {
        if (!dataDefined || !id) return;
        const nome = nomeNovoDocumento.trim();
        if (!nome) {
            setUploadDocumentoError('Informe o nome do documento.');
            return;
        }
        if (!arquivoNovoDocumento || arquivoNovoDocumento.size === 0) {
            setUploadDocumentoError('Selecione um arquivo.');
            return;
        }
        setUploadDocumentoError(null);
        setUploadDocumentoLoading(true);
        try {
            const formData = new FormData();
            formData.append('cnpj', dataDefined.CnpjOuCpf);
            const nomeOriginal = arquivoNovoDocumento.name;
            const ultimoPonto = nomeOriginal.lastIndexOf('.');
            const extensao = ultimoPonto !== -1 ? nomeOriginal.substring(ultimoPonto) : '';
            const temExtensao = nome.includes('.') && nome.lastIndexOf('.') > nome.length - 6;
            const nomeFinal = temExtensao ? nome : nome + extensao;
            const arquivoComNome = new File([arquivoNovoDocumento], nomeFinal, {
                type: arquivoNovoDocumento.type,
                lastModified: arquivoNovoDocumento.lastModified
            });
            formData.append('files', arquivoComNome);

            const config = {
                headers: {
                    'accept': 'application/json',
                    'Authorization': headers().Authorization,
                },
            };
            const response = await apiExtractor.post<string[]>('/documento/upload-petro', formData, config);
            const linksRetornados: string[] = Array.isArray(response.data) ? response.data : [response.data];
            if (linksRetornados.length === 0) {
                setUploadDocumentoError('Nenhum link retornado pelo servidor.');
                return;
            }
            const urlsAtuais = dataDefined.UrlDocumentos ?? [];
            const updatedData = { ...dataDefined, UrlDocumentos: [...urlsAtuais, ...linksRetornados] };
            const payload = {
                id: id,
                codigoGrupo: codigoGrupo,
                nomeGrupo: updatedData.NomeGrupoEconomico ?? '',
                codigoCliente: sumulaPetrobahia.codigoCliente ?? '',
                versaoSumula: sumulaPetrobahia.VersaoSumula ?? sumulaPetrobahia.versaoSumula,
                dataCriacao: new Date().toISOString(),
                usuarioCriacao: sumulaPetrobahia.usuarioCriacao ?? '',
                jsonSumula: JSON.stringify(updatedData),
                statusSumula: sumulaPetrobahia.statusSumula ?? 0,
                aprovado: sumulaPetrobahia.aprovado ?? false,
                estadoAtual: sumulaPetrobahia.estadoAtual ?? 0,
            };
            const putConfig = {
                headers: { ...headers(), 'Content-Type': 'application/json' },
            };
            await apiPetro.put('analise/atualizarsumula', payload, putConfig);
            const freshSumula = await fetchSumula(id);
            if (freshSumula) setSumulaPetrobahia(freshSumula);
            setNomeNovoDocumento('');
            setArquivoNovoDocumento(null);
            if (document.getElementById('sumula-novo-doc-file')) (document.getElementById('sumula-novo-doc-file') as HTMLInputElement).value = '';
        } catch (err: any) {
            const msg = err?.response?.data?.message ?? err?.message ?? 'Erro ao enviar documento.';
            setUploadDocumentoError(typeof msg === 'string' ? msg : 'Erro ao enviar documento.');
        } finally {
            setUploadDocumentoLoading(false);
        }
    };

    return (
        <>
            <Header />
            <br />
            <Container ref={sumulaRef}>
                <Title>Análise do limite de crédito</Title>

                <Section>
                    <SubTitle>Dados cadastrais básicos</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>Nome do Grupo</Th>
                                <Th>Código</Th>
                                <Th>Código Cliente</Th>
                                <Th>Modalidade</Th>
                                <Th>Conceito</Th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={dataDefined.NomeGrupoEconomico ?? ''}
                                        onChange={(e) => {
                                            const updatedData = { ...dataDefined };
                                            updatedData.NomeGrupoEconomico = e.target.value;
                                            setSumulaPetrobahia({ ...sumulaPetrobahia, sumulaData: updatedData });
                                        }}
                                        placeholder="Nome do Grupo"
                                        style={{ minHeight: 0, height: 38 }}
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={codigoGrupo}
                                        onChange={(e: any) => setCodigoGrupo(e.target.value)}
                                        placeholder="Código"
                                        style={{ minHeight: 0, height: 38 }}
                                    />
                                </Td>
                                <Td>{sumulaPetrobahia?.codigoCliente ?? '—'}</Td>
                                <Td>
                                    <select
                                        value={modalidade}
                                        onChange={e => setModalidade(e.target.value)}
                                        style={{ width: '100%', minHeight: 38, borderRadius: 4, border: '1px solid var(--border-default)', padding: 6 }}
                                    >
                                        <option value="Definitivo">Definitivo</option>
                                        <option value="Venda a venda">Venda a venda</option>
                                        <option value="Provisório">Provisório</option>
                                        <option value="Intraday">Intraday</option>
                                    </select>
                                </Td>
                                <Td>
                                    <select
                                        value={conceito}
                                        onChange={e => setConceito(e.target.value)}
                                        style={{ width: '100%', minHeight: 38, borderRadius: 4, border: '1px solid var(--border-default)', padding: 6 }}
                                    >
                                        <option value="Excelente">Excelente</option>
                                        <option value="Bom">Bom</option>
                                        <option value="Regular">Regular</option>
                                    </select>
                                </Td>
                            </tr>
                        </tbody>
                    </Table>
                    <Table>
                        <thead>
                            <tr>
                                <Th>Limite Atual</Th>
                                <Th>Limite Proposto</Th>
                                <Th>Limite Sugerido CreditOn</Th>
                                <Th>Vigência do Crédito</Th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={formatCurrencyFromReais(dataDefined.LimiteAtual?.toString() ?? '')}
                                        placeholder="Limite Atual"
                                        style={{ minHeight: 0, height: 38 }}
                                        readOnly
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={maskCurrency(limiteProposto)}
                                        onChange={(e: any) => setLimiteProposto(unmaskCurrency(e.target.value))}
                                        placeholder="Limite Proposto"
                                        style={{ minHeight: 0, height: 38 }}
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={formatCurrencyFromReais(dataDefined.LimiteSugerido?.toString() ?? '')}
                                        placeholder="Limite Sugerido"
                                        style={{ minHeight: 0, height: 38 }}
                                        readOnly
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={dataDefined.VigenciaCredito}
                                        onChange={(e) => {
                                            const updatedData = { ...dataDefined };
                                            updatedData.VigenciaCredito = e.target.value;
                                            setSumulaPetrobahia({ ...sumulaPetrobahia, sumulaData: updatedData });
                                        }}
                                        placeholder="Vigência do Crédito"
                                        style={{ minHeight: 0, height: 38 }}
                                    />
                                </Td>
                            </tr>
                        </tbody>
                    </Table>

                    {/* TABELA DE DADOS BÁSICOS ANTES DOS DADOS DE CONTATO */}
                    <Table>
                        <tbody>
                            <tr>
                                <Th>Nome do Grupo</Th>
                                <Td>{dataDefined.NomeGrupoEconomico}</Td>
                                <Th>Razão Social</Th>
                                <Td>{dataDefined.RazaoSocial}</Td>
                            </tr>
                            <tr>
                                <Th>Nome Fantasia</Th>
                                <Td>{dataDefined.NomeFantasia}</Td>
                                <Th>CNPJ/CPF</Th>
                                <Td>{maskCnpjCpf(dataDefined.CnpjOuCpf)}</Td>
                            </tr>
                            <tr>
                                <Th>Data de Fundação</Th>
                                <Td>{formatDateToBR(dataDefined.DataFundacao)}</Td>
                                <Th>Data de Cadastro</Th>
                                <Td>{formatDateToBR(dataDefined.DataCadastro)}</Td>
                            </tr>
                            <tr>
                                <Th>Capital Social</Th>
                                <Td>{formatCurrencyFromReais(dataDefined.CapitalSocial?.toString() ?? '')}</Td>
                                <Th>Inscrição Estadual</Th>
                                <Td>{dataDefined.InscricaoEstadual}</Td>
                            </tr>
                            <tr>
                                <Th>Classificação</Th>
                                <Td>{dataDefined.Classificacao}</Td>
                                <Th>Tipo de Cliente</Th>
                                <Td>{mapTipoCliente(dataDefined.TipoCliente)}</Td>
                            </tr>
                        </tbody>
                    </Table>

                    <SubTitle style={{ marginTop: 24 }}>Contato</SubTitle>
                    <Table>
                        <tbody>
                            <tr>
                                <Th>Nome do Contato</Th>
                                <Td>{dataDefined.NomeContato}</Td>
                                <Th>Email do Contato</Th>
                                <Td>{dataDefined.EmailContato}</Td>
                            </tr>
                            <tr>
                                <Th>Telefone do Contato</Th>
                                <Td>{maskPhone(dataDefined.TelefoneContato)}</Td>
                                <Th>Login</Th>
                                <Td>{dataDefined.Login}</Td>
                            </tr>
                        </tbody>
                    </Table>

                    <SubTitle style={{ marginTop: 24 }}>Informações Comerciais</SubTitle>
                    <Table>
                        <tbody>
                            <tr>
                                <Th>Conceito do Cliente</Th>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={conceitoCliente}
                                        onChange={(e: any) => setConceitoCliente(e.target.value)}
                                        placeholder="Conceito do Cliente"
                                        style={{ minHeight: 0, height: 38 }}
                                    />
                                </Td>
                                <Th>Tipo de Propriedade</Th>
                                <Td>{dataDefined.TipoPropriedade}</Td>
                            </tr>
                            <tr>
                                <Th>Tempo de Atividade Pessoa Física</Th>
                                <Td>{dataDefined.TempoAtividadePessoaFisica}</Td>
                                <Th>Inadimplente</Th>
                                <Td>{dataDefined.Inadimplente ? 'Sim' : 'Não'}</Td>
                            </tr>
                            <tr>
                                <Th>Percentual Venda à Vista</Th>
                                <Td>{dataDefined.PercentualVendaVista}</Td>
                                <Th>Percentual Venda a Prazo</Th>
                                <Td>{dataDefined.PercentualVendaPrazo}</Td>
                            </tr>
                            <tr>
                                <Th>Limite</Th>
                                <Td>{formatCurrencyFromReais(dataDefined.LimiteAtual?.toString() ?? '')}</Td>
                                <Th>Prazo Pagamento</Th>
                                <Td>{dataDefined.PrazoPagamento}</Td>
                            </tr>
                            <tr>
                                <Th>Nome Assessor</Th>
                                <Td colSpan={3}>{dataDefined.NomeAssessor}</Td>
                            </tr>
                        </tbody>
                    </Table>
                                        
                    {!shouldHideButtons && (
                        <SaveButton 
                            onClick={handleSaveFields}
                            disabled={isLoading}
                            style={{ marginTop: '20px' }}
                        >
                            {isLoading ? 'Salvando...' : 'Salvar Dados'}
                        </SaveButton>
                    )}
                </Section>

                <Section>
                    <SubTitle>Dados comerciais, operacionais e econômicos</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>CNPJ/CPF</Th>
                                <Th>Razão Social</Th>
                                <Th>Tipo de Cliente</Th>
                                <Th>Nome do Contato</Th>
                                <Th>E-mail do Contato</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Principal */}
                            <tr>
                                <Td>{maskCnpjCpf(dataDefined.CnpjOuCpf)}</Td>
                                <Td>{dataDefined.RazaoSocial}</Td>
                                <Td>{mapTipoCliente(dataDefined.TipoCliente)}</Td>
                                <Td>{dataDefined.NomeContato}</Td>
                                <Td>{dataDefined.EmailContato}</Td>
                            </tr>
                            {/* Grupo Econômico */}
                            {dataDefined.GrupoEconomico.map((g, i) => (
                                <tr key={i}>
                                    <Td>{maskCnpjCpf(g.CnpjOuCpf)}</Td>
                                    <Td>{g.RazaoSocial}</Td>
                                    <Td>{mapTipoCliente(g.TipoCliente)}</Td>
                                    <Td>{g.NomeContato}</Td>
                                    <Td>{g.EmailContato}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>

                <Section>
                    <SubTitle>Expectativa de Consumo Mensal</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th rowSpan={2}>CNPJ/CPF</Th>
                                <Th rowSpan={2}>Combustível</Th>
                                <Th>Consumo do Cliente</Th>
                                <Th>Expectativa PB</Th>
                                <Th>Margem Litro</Th>
                                <Th>Preço Litro</Th>
                                <Th>Prazo p. pagamento</Th>
                                <Th>Giro Operacional</Th>
                                <Th>Tipo p. pagamento</Th>
                            </tr>
                            <tr>
                                {/* Subcabeçalhos para os campos adicionais */}
                                <Th colSpan={1}></Th>
                                <Th colSpan={1}></Th>
                                <Th colSpan={1}></Th>
                                <Th colSpan={1}></Th>
                                <Th colSpan={1}></Th>
                                <Th colSpan={1}></Th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Principal */}
                            {['Gasolina', 'Diesel', 'Diesel_S10', 'Etanol', 'Gas'].map((comb, idx) => (
                                <tr key={`principal-${comb}`}>
                                    {idx === 0 && (
                                        <Td rowSpan={5} style={{ verticalAlign: 'middle' }}>{maskCnpjCpf(dataDefined.CnpjOuCpf)}</Td>
                                    )}
                                    <Td>{comb === 'Gas' ? 'Gás' : comb.replace('_', ' ')}</Td>
                                    <Td>{maskNumber(dataDefined.ExpectativaConsumo[comb as keyof typeof dataDefined.ExpectativaConsumo])}</Td>
                                    <Td>
                                        <ParecerTextArea
                                            as="input"
                                            value={maskThousands(expectativaPB[comb as keyof typeof expectativaPB])}
                                            onChange={(e: any) => {
                                                const unmaskedValue = unmaskThousands(e.target.value);
                                                setExpectativaPB({
                                                    ...expectativaPB,
                                                    [comb]: unmaskedValue
                                                });
                                            }}
                                            placeholder="Expectativa PB"
                                            style={{ minHeight: 0, height: 38, width: '100px' }}
                                        />
                                    </Td>
                                    <Td>
                                        <ParecerTextArea
                                            as="input"
                                            value={margemLitro[comb as keyof typeof margemLitro]}
                                            onChange={(e: any) => setMargemLitro({
                                                ...margemLitro,
                                                [comb]: e.target.value
                                            })}
                                            placeholder="Margem Litro"
                                            style={{ minHeight: 0, height: 38, width: '100px' }}
                                        />
                                    </Td>
                                    <Td>
                                        <ParecerTextArea
                                            as="input"
                                            value={precoLitroDisplay[comb as keyof typeof precoLitroDisplay]}
                                            onChange={(e: any) => {
                                                const value = validatePriceInput(e.target.value);
                                                setPrecoLitroDisplay({
                                                    ...precoLitroDisplay,
                                                    [comb]: value
                                                });
                                            }}
                                            onBlur={(e: any) => {
                                                const unmasked = unmaskPriceFromAPI(e.target.value);
                                                setPrecoLitro({
                                                    ...precoLitro,
                                                    [comb]: unmasked
                                                });
                                                // Reformata para garantir consistência
                                                if (unmasked) {
                                                    setPrecoLitroDisplay({
                                                        ...precoLitroDisplay,
                                                        [comb]: formatPriceFromAPI(unmasked)
                                                    });
                                                }
                                            }}
                                            onFocus={(e: any) => {
                                                // Se está formatado, permite edição direta
                                                if (e.target.value.includes('R$')) {
                                                    e.target.select();
                                                }
                                            }}
                                            placeholder="0,0000"
                                            style={{ minHeight: 0, height: 38, width: '120px' }}
                                        />
                                    </Td>
                                    <Td>
                                        <ParecerTextArea
                                            as="input"
                                            value={prazoPagamento[comb as keyof typeof prazoPagamento]}
                                            onChange={(e: any) => setPrazoPagamento({
                                                ...prazoPagamento,
                                                [comb]: e.target.value
                                            })}
                                            placeholder="Prazo em dias"
                                            style={{ minHeight: 0, height: 38, width: '80px' }}
                                            type="number"
                                        />
                                    </Td>
                                    <Td>
                                        {calcularGiroOperacional(
                                            expectativaPB[comb as keyof typeof expectativaPB],
                                            precoLitro[comb as keyof typeof precoLitro] || '',
                                            prazoPagamento[comb as keyof typeof prazoPagamento] || ''
                                        )}
                                    </Td>
                                    <Td>
                                        <select
                                            value={tipoPagamento[comb as keyof typeof tipoPagamento]}
                                            onChange={(e) => setTipoPagamento({
                                                ...tipoPagamento,
                                                [comb]: e.target.value
                                            })}
                                            style={{
                                                minHeight: 38,
                                                height: 38,
                                                width: '100px',
                                                padding: '5px',
                                                border: '1px solid var(--border-default)',
                                                borderRadius: '4px',
                                                backgroundColor: 'var(--surface-raised)',
                                                fontSize: '14px'
                                            }}
                                        >
                                            <option value="À vista">À vista</option>
                                            <option value="A prazo">A prazo</option>
                                        </select>
                                    </Td>
                                </tr>
                            ))}
                            
                            {/* Linha de Total do Giro Operacional */}
                            <tr style={{ backgroundColor: 'var(--surface-sunken)', fontWeight: 'bold' }}>
                                <Td></Td>
                                <Td style={{ textAlign: 'center', fontWeight: 'bold' }}>TOTAL</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td style={{ fontWeight: 'bold' }}>
                                    {(() => {
                                        let total = 0;
                                        ["Gasolina", "Diesel", "Diesel_S10", "Etanol", "Gas"].forEach(comb => {
                                            const giroStr = calcularGiroOperacional(
                                                expectativaPB[comb as keyof typeof expectativaPB],
                                                precoLitro[comb as keyof typeof precoLitro] || '',
                                                prazoPagamento[comb as keyof typeof prazoPagamento] || ''
                                            );
                                            if (giroStr) {
                                                const giroValue = parseFloat(giroStr.replace(/[R$\s\.]/g, '').replace(',', '.')) || 0;
                                                total += giroValue;
                                            }
                                        });
                                        return total.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                            minimumFractionDigits: 4,
                                            maximumFractionDigits: 4
                                        });
                                    })()}
                                </Td>
                            </tr>
                                                    
                            {/* Linha de Total Geral */}
                            <tr style={{ backgroundColor: 'var(--surface-sunken)', fontWeight: 'bold', borderTop: '2px solid var(--border-hairline)' }}>
                                <Td></Td>
                                <Td style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px' }}>TOTAL GERAL</Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td></Td>
                                <Td style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(() => {
                                        let totalGeral = 0;
                                        
                                        // Soma do principal
                                        ["Gasolina", "Diesel", "Diesel_S10", "Etanol", "Gas"].forEach(comb => {
                                            const giroStr = calcularGiroOperacional(
                                                expectativaPB[comb as keyof typeof expectativaPB],
                                                precoLitro[comb as keyof typeof precoLitro] || '',
                                                prazoPagamento[comb as keyof typeof prazoPagamento] || ''
                                            );
                                            if (giroStr) {
                                                const giroValue = parseFloat(giroStr.replace(/[R$\s\.]/g, '').replace(',', '.')) || 0;
                                                totalGeral += giroValue;
                                            }
                                        });
                                        
                                        return totalGeral.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL',
                                            minimumFractionDigits: 4,
                                            maximumFractionDigits: 4
                                        });
                                    })()}
                                </Td>
                            </tr>
                            
                        </tbody>
                    </Table>
                </Section>

                <Section>
                    <SubTitle>Composição societária/Administração</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>Razão Social</Th>
                                <Th>CNPJ/CPF</Th>
                                <Th>Participação</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataDefined.Socios.map((s, i) => (
                                <tr key={i}>
                                    <Td>{s.RazaoSocial}</Td>
                                    <Td>{maskCnpjCpf(s.CnpjOuCpf)}</Td>
                                    <Td>{s.ParticipacaoSocietaria}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>

                <Section>
                    <SubTitle>Análise - critérios de aceitação, Rating, Score e Limite sugerido</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>CNPJ/CPF</Th>
                                <Th>Razão Social</Th>
                                <Th>Limite Sugerido</Th>
                                <Th>Restritivos Financeiros</Th>
                                <Th>Cadastro Receita Federal</Th>
                                <Th>Situação Especial</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Principal */}
                            <tr>
                                <Td>{maskCnpjCpf(dataDefined.CnpjOuCpf)}</Td>
                                <Td>{dataDefined.RazaoSocial}</Td>
                                <Td>{formatCurrencyFromReais(dataDefined.Analise?.LimiteSugerido.toString() || '')}</Td>
                                <Td>{dataDefined.Analise?.RestritivosFinanceiros}</Td>
                                <Td>{dataDefined.Analise?.CadastroReceitaFederal}</Td>
                                <Td>{dataDefined.Analise?.SituacaoEspecial}</Td>
                            </tr>
                            {/* Grupo Econômico */}
                            {dataDefined.GrupoEconomico.map((g, i) => (
                                <tr key={i}>
                                    <Td>{maskCnpjCpf(g.CnpjOuCpf)}</Td>
                                    <Td>{g.RazaoSocial}</Td>
                                    <Td>{formatCurrencyFromReais(g.Analise?.LimiteSugerido.toString() || '')}</Td>
                                    <Td>{g.Analise?.RestritivosFinanceiros}</Td>
                                    <Td>{g.Analise?.CadastroReceitaFederal}</Td>
                                    <Td>{g.Analise?.SituacaoEspecial}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>

                <Section>
                    <SubTitle>Detalhes de Análise</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>CNPJ/CPF</Th>
                                <Th>Razão Social</Th>
                                <Th>Tempo Fundação</Th>
                                <Th>Ceis</Th>
                                <Th>Cnep</Th>
                                <Th>Score</Th>
                                <Th>Rating</Th>
                                <Th>Qtd Restrições</Th>
                                <Th>Valor Restrições</Th>
                                <Th>Relatório</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Principal */}
                            <tr>
                                <Td>{maskCnpjCpf(dataDefined.CnpjOuCpf)}</Td>
                                <Td>{dataDefined.RazaoSocial}</Td>
                                <Td>{dataDefined.Analise?.TempoFundacao}</Td>
                                <Td>{dataDefined.Analise?.Ceis}</Td>
                                <Td>{dataDefined.Analise?.Cnep}</Td>
                                <Td>{dataDefined.Analise?.Score}</Td>
                                <Td>{dataDefined.Analise?.Rating}</Td>
                                <Td>{dataDefined.Analise?.QuantidadeRestricoes}</Td>
                                <Td>{dataDefined.Analise?.ValorRestricoes}</Td>
                                <Td>
                                    {dataDefined.Analise?.UrlRelatorio ? (
                                        <a
                                            href={dataDefined.Analise.UrlRelatorio}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                            title="Baixar relatório"
                                            style={{ color: "var(--action-link)", fontSize: 18, display: "inline-flex", alignItems: "center" }}
                                        >
                                            {/* SVG de download */}
                                            <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" style={{ verticalAlign: "middle" }}>
                                                <path d="M13 10V3H7v7H4l6 7 6-7h-3zM4 18h12v-2H4v2z"/>
                                            </svg>
                                        </a>
                                    ) : (
                                        '-'
                                    )}
                                </Td>
                            </tr>
                            {/* Grupo Econômico */}
                            {dataDefined.GrupoEconomico.map((g, i) => (
                                <tr key={i}>
                                    <Td>{maskCnpjCpf(g.CnpjOuCpf)}</Td>
                                    <Td>{g.RazaoSocial}</Td>
                                    <Td>{g.Analise?.TempoFundacao}</Td>
                                    <Td>{g.Analise?.Ceis}</Td>
                                    <Td>{g.Analise?.Cnep}</Td>
                                    <Td>{g.Analise?.Score}</Td>
                                    <Td>{g.Analise?.Rating}</Td>
                                    <Td>{g.Analise?.QuantidadeRestricoes}</Td>
                                    <Td>{g.Analise?.ValorRestricoes}</Td>
                                    <Td>
                                        {g.Analise?.UrlRelatorio ? (
                                            <a
                                                href={g.Analise.UrlRelatorio}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                                title="Baixar relatório"
                                                style={{ color: "var(--action-link)", fontSize: 18, display: "inline-flex", alignItems: "center" }}
                                            >
                                                {/* SVG de download */}
                                                <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" style={{ verticalAlign: "middle" }}>
                                                    <path d="M13 10V3H7v7H4l6 7 6-7h-3zM4 18h12v-2H4v2z"/>
                                                </svg>
                                            </a>
                                        ) : (
                                            '-'
                                        )}
                                    </Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Section>



                <Section>
                    <SubTitle>Pareceres e Decisões</SubTitle>
                    <div>
                        <h3>Parecer geral do Assessor Comercial</h3>
                     <ParecerTextArea
                        value={parecerAssessor}
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setParecerAssessor(e.target.value)}
                        placeholder="Digite o parecer do Assessor Comercial"
                        rows={4}
                        disabled={user?.perfil !== 'Assessor'}
                        />

                        {(user?.perfil === 'Assessor' && sumulaPetrobahia?.estadoAtual === 0) && !shouldHideButtons && (
                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                            <SaveButton onClick={() => handleSave(parecerAssessor, 'Assessor Comercial', true)}
                            disabled={isLoading}
                            >
                                {isLoading ? 'Salvando...' : 'Salvar e Enviar'}
                            </SaveButton>
                               
                            <SaveButton onClick={handleDraftSave}>
                                 {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                            </SaveButton>

                            <ReturnButton onClick={() => handleSave(parecerAssessor, 'Assessor Comercial', false)}
                            disabled={isLoading}
                            >
                                {isLoading ? 'Voltando...' : 'Voltar'}
                            </ReturnButton>
                            
                        </div>
                            

                        )}
                        <h3>Parecer geral da Gestão de Riscos</h3>
                        <ParecerTextArea
                            value={parecerRiscos}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setParecerRiscos(e.target.value)}
                            placeholder="Digite o parecer da Gestão de Riscos"
                            rows={4}
                            disabled={user?.perfil !==  'Gestor'}
                        />

                        {(user?.perfil === 'Gestor' && (sumulaPetrobahia?.estadoAtual === 1 || sumulaPetrobahia?.estadoAtual === 5)
                            ) && !shouldHideButtons && (
                            <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                <SaveButton onClick={() => handleSave(parecerRiscos, 'Gestão de Riscos', true)}
                                disabled={isLoading}
                                >
                                    {isLoading ? 'Salvando...' : 'Salvar e Enviar'}
                                </SaveButton>
                                
                                <SaveButton onClick={handleDraftSave}>
                                    {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                                </SaveButton>

                                <ReturnButton onClick={() => handleSave(parecerRiscos, 'Gestão de Riscos', false)}
                                disabled={isLoading}
                                >
                                    {isLoading ? 'Voltando...' : 'Voltar'}
                                </ReturnButton>

                                <SaveButton
                                    onClick={() => handleUpdateStatus(5, 5)}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Despacha...' : 'Despachar'}
                                </SaveButton>

                                <SaveButton
                                    onClick={() => handleUpdateStatus(6, 6)}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Finalizando...' : 'Finalizar'}
                                </SaveButton>
                            </div>
                        )}

                        <h3>Parecer geral da Coordenação de Riscos</h3>
                        <ParecerTextArea
                            value={parecerCoordenacao}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setParecerCoordenacao(e.target.value)}
                            placeholder="Digite o parecer da Coordenação de Riscos"
                            rows={4}
                            disabled={user?.perfil !==  'Coordenador'}
                        />

                        {(user?.perfil === 'Coordenador' && sumulaPetrobahia?.estadoAtual === 3) && !shouldHideButtons && (
                        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                            <SaveButton onClick={() => handleSave(parecerCoordenacao, 'Coordenação de Riscos', true)}
                            disabled={isLoading}
                            >
                                {isLoading ? 'Salvando...' : 'Salvar e Enviar'}
                            </SaveButton>
                               
                            <SaveButton onClick={handleDraftSave}>
                                 {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                            </SaveButton>

                            <ReturnButton onClick={() => handleSave(parecerCoordenacao, 'Coordenação de Riscos', false)}
                            disabled={isLoading}
                            >
                                {isLoading ? 'Enviando...' : 'Enviar para Gestão de Riscos'}
                            </ReturnButton>

                            <SaveButton
                                onClick={() => handleUpdateStatus(0, 0)}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Enviando...' : 'Enviar Assessor'}
                            </SaveButton>

                            <SaveButton
                                onClick={async () => {
                                    await handleSave(parecerCoordenacao, 'Coordenação de Riscos', true);
                                    await handleUpdateStatus(5, 5);
                                }}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Despachando...' : 'Despachar'}
                            </SaveButton>
                        
                        </div>
                        )}
                    </div>
                </Section>

                {/* Seção de Documentos Anexos: upload acima, lista abaixo */}
                <Section>
                    <SubTitle>Documentos Anexos</SubTitle>
                    <div style={{ marginBottom: 16, padding: 12, border: '1px solid var(--border-default)', borderRadius: 8, backgroundColor: 'var(--surface-canvas)' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 12, marginBottom: 8 }}>
                            <div style={{ minWidth: 200 }}>
                                <label style={{ display: 'block', marginBottom: 4, fontSize: 12, fontWeight: 600 }}>Nome do documento (obrigatório)</label>
                                <input
                                    type="text"
                                    value={nomeNovoDocumento}
                                    onChange={(e) => { setNomeNovoDocumento(e.target.value); setUploadDocumentoError(null); }}
                                    placeholder="Ex: Contrato social"
                                    style={{ width: '100%', padding: 8, border: '1px solid var(--border-default)', borderRadius: 4 }}
                                    disabled={uploadDocumentoLoading}
                                />
                            </div>
                            <div style={{ minWidth: 200 }}>
                                <label style={{ display: 'block', marginBottom: 4, fontSize: 12, fontWeight: 600 }}>Arquivo</label>
                                <input
                                    id="sumula-novo-doc-file"
                                    type="file"
                                    onChange={(e) => { setArquivoNovoDocumento(e.target.files?.[0] ?? null); setUploadDocumentoError(null); }}
                                    style={{ width: '100%', padding: 4 }}
                                    disabled={uploadDocumentoLoading}
                                />
                            </div>
                            <SaveButton
                                onClick={handleUploadDocumentoSumula}
                                disabled={uploadDocumentoLoading || !nomeNovoDocumento.trim() || !arquivoNovoDocumento}
                                style={{ padding: '8px 16px' }}
                            >
                                {uploadDocumentoLoading ? 'Enviando...' : 'Enviar documento'}
                            </SaveButton>
                        </div>
                        {uploadDocumentoError && (
                            <div style={{ color: 'var(--error)', fontSize: 13, marginTop: 8 }}>{uploadDocumentoError}</div>
                        )}
                    </div>
                    {dataDefined?.UrlDocumentos && dataDefined.UrlDocumentos.length > 0 && (
                        <Table>
                            <thead>
                                <tr>
                                    <Th>Nome do Documento</Th>
                                    <Th>Ações</Th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataDefined.UrlDocumentos.map((urlDocumento, index) => {
                                    const nomeDocumento = urlDocumento.split('/').pop() || `Documento ${index + 1}`;
                                    return (
                                        <tr key={index}>
                                            <Td>{decodeURIComponent(nomeDocumento)}</Td>
                                            <Td>
                                                <SaveButton 
                                                    onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = urlDocumento;
                                                        link.download = nomeDocumento;
                                                        link.target = '_blank';
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }}
                                                    style={{ padding: '4px 12px', fontSize: '12px', backgroundColor: 'var(--success)' }}
                                                >
                                                    Download
                                                </SaveButton>
                                            </Td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    )}
                </Section>

                <Section>
                    <SubTitle>Decisão Escalão Deferidor / Diretoria</SubTitle>
                    <Table>
                        <thead>
                            <tr>
                                <Th>Nome do Grupo</Th>
                                <Th>Decisão</Th>
                                <Th>Condicionantes</Th>
                                <Th>Limite de Crédito</Th>
                                <Th>Prazo Deferido (em dias)</Th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <Td>{dataDefined.NomeGrupoEconomico}</Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={decisao}
                                        onChange={e => setDecisao(e.target.value)}
                                        placeholder="Digite a decisão"
                                        style={{ minHeight: 0, height: 38 }}
                                        disabled={user?.perfil !== 'Diretoria'}
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={condicionantes}
                                        onChange={e => setCondicionantes(e.target.value)}
                                        placeholder="Digite as condicionantes"
                                        style={{ minHeight: 0, height: 38 }}
                                        disabled={user?.perfil !== 'Diretoria'}
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={limiteCredito}
                                        onChange={e => setLimiteCredito(e.target.value)}
                                        placeholder="Digite o limite de crédito"
                                        style={{ minHeight: 0, height: 38 }}
                                        disabled={user?.perfil !== 'Diretoria'}
                                    />
                                </Td>
                                <Td>
                                    <ParecerTextArea
                                        as="input"
                                        value={prazoDeferido}
                                        onChange={e => setPrazoDeferido(e.target.value)}
                                        placeholder="Digite o prazo em dias"
                                        style={{ minHeight: 0, height: 38 }}
                                        type="number"
                                        disabled={user?.perfil !== 'Diretoria'}
                                    />
                                </Td>
                            </tr>
                        </tbody>
                    </Table>

                    {user?.perfil === 'Diretoria' && !shouldHideButtons && (
                        <div>
                            <SaveButton style={{ margin: '1%' }}
                            onClick={async () => {
                                setIsLoading(true);
                                // Monta o objeto conforme DecisaoDiretoriaModel
                                const decisaoDiretoria: DecisaoDiretoriaModel = {
                                    codigoGrupo: codigoGrupo,
                                    limiteAtual: dataDefined.LimiteAtual?.toString() ?? '',
                                    limiteProposto: limiteProposto,
                                    limiteSugerido: dataDefined.LimiteSugerido?.toString() ?? '',
                                    decisao,
                                    condicionantes,
                                    limiteCredito,
                                    modalidade,
                                    conceito,
                                    prazoDeferido,
                                };

                                // Atualiza no objeto principal (opcional, se quiser salvar no jsonSumula)
                                if (dataDefined) {
                                    (dataDefined as any).DecisaoDiretoria = decisaoDiretoria;
                                }

                                // Chama handleSave para atualizar a súmula
                                await handleSave('', 'Diretoria', true);

                                setIsLoading(false);
                            }}
                            >
                                {isLoading ? 'Salvando...' : 'Deferir/Indeferir'}
                            </SaveButton>
                        </div>
                    )}
                </Section>
                <Section>
                    {!shouldHideButtons && (
                        <SaveButton onClick={handleDownloadSumulaCompleta}>Download sumula</SaveButton>
                    )}
                </Section>
          </Container>
        </> 
    );
};